import { jsx } from "react/jsx-runtime";
import { useTheme, useThemeProps } from "@mui/material";
import { forwardRef } from "react";
import { useSlotProps } from "../../../base/index.js";
import { useToolbarView } from "../hooks/useToolbarView.js";
import { toolbarMenuName } from "./classes.js";
import { Root } from "./components/Root.js";
import { useUtilityClasses } from "./hooks/useUtilityClasses.js";
const defaultAnchorOrigin = {
  horizontal: "right",
  vertical: "top"
};
const ToolbarMenu = forwardRef(function ToolbarMenu2(inProps, ref) {
  const props = useThemeProps({
    name: toolbarMenuName,
    props: inProps
  });
  const {
    anchorOrigin = defaultAnchorOrigin,
    children,
    className = "",
    components,
    componentsProps,
    sx,
    testId = `${toolbarMenuName}-root`,
    value,
    ...rest
  } = props;
  const { isOpen, handleClose, target, railWidth } = useToolbarView({ value });
  const open = Boolean(target) && isOpen;
  const theme = useTheme();
  const halfUnit = Number.parseInt(theme.spacing(0.5));
  const marginThreshold = railWidth + halfUnit;
  const ownerState = props;
  const utilityClasses = useUtilityClasses(ownerState);
  const rootSlotProps = useSlotProps({
    className: `${className} ${utilityClasses.root}`,
    elementType: Root,
    externalSlotProps: componentsProps?.root,
    ownerState,
    additionalProps: {
      "data-testid": testId,
      "data-tidal": toolbarMenuName,
      anchorOrigin,
      anchorEl: target,
      as: components?.Root,
      marginThreshold,
      ref,
      sx,
      ...rest,
      onClose: handleClose,
      open
    }
  });
  return /* @__PURE__ */ jsx(Root, { ...rootSlotProps, children });
});
export {
  ToolbarMenu
};
//# sourceMappingURL=ToolbarMenu.js.map
